// this really just enforces using a legend when using a fieldset
import { PropsWithChildren, ReactNode } from 'react';

type Props = PropsWithChildren<{
  fieldsetClassName?: string;
  legend: ReactNode;
  legendClassName?: string;
}>;

const Fieldset = ({ children, fieldsetClassName, legend, legendClassName }: Props) => (
  <fieldset className={fieldsetClassName}>
    <legend className={legendClassName}>{legend}</legend>
    {children}
  </fieldset>
);

export default Fieldset;
